module.exports = __webpack_public_path__ + "static/media/HKD.8a08418e.svg";